import { FC, useEffect, useState } from 'react'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import classes from './index.module.css'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import cn from 'classnames'
import FinancialTransactionsReport from '../FinancialTransactionsReport/FinancialTransactionsReport'

interface FinancialTransactionsReportModalProps {
  userId: number
  open: boolean
  onClose: () => void
}

const ModalContent: FC<FinancialTransactionsReportModalProps> = ({
  userId,
  open,
  onClose,
}) => {
  return (
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>История списаний и начислений</span>
        </div>
        <div className={mclasses.closeIcon} onClick={() => onClose()}>
          <IcoRemove />
        </div>
      </div>
      <div className={cn(mclasses.formWrapper, classes.formWrapper)}>
        <div className={cn(classes.list, 'customScroll')}>
          <FinancialTransactionsReport userId={userId} />
        </div>
      </div>
    </div>
  )
}

const FinancialTransactionsReportModal: FC<
  FinancialTransactionsReportModalProps
> = (props) => {
  const { open, onClose } = props

  return (
    <Modal
      active={open}
      className={cn(mclasses.modalWrapper, classes.modalWrapper) as any}
      setActive={() => onClose()}
    >
      <ModalContent {...props} />
    </Modal>
  )
}

export default FinancialTransactionsReportModal
